import * as React from 'react';
import { SVGProps } from 'react';

const IconTranslateSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26 26h-2.62l-1.468-3.6H15.69L14.22 26H11.6l5.896-14.4h2.621L26 26Zm-9.724-6h4.653l-2.13-6-2.523 6Z"
    />
    <path d="M16.4 9.2h-2.399l-1.818 4.097-3.395 3.393 3.395 3.395-1.698 1.697-3.394-3.394-3.394 3.394L2 20.085l3.394-3.395L2 13.297 3.697 11.6l3.394 3.392 3.394-3.393 1.116-2.4H2V6.8h14.4v2.4ZM11.6 4.4H6.8V2h4.8v2.4Z" />
  </svg>
);
export default IconTranslateSizeL;
